import { ArrayIndexOutOfBoundsException3rm3ooo7dx3e8 as ArrayIndexOutOfBoundsException } from './NonJvmPlatform.mjs';
import { subtract2orl8z9upxd9l as subtract } from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { UnsafeCursor3vg8iqxvd6n5k as UnsafeCursor } from './Buffer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DEFAULT__new_UnsafeCursor;
function get_DEFAULT__ByteString_size() {
  _init_properties_Util_kt__laey5a();
  return DEFAULT__ByteString_size;
}
var DEFAULT__ByteString_size;
function resolveDefaultParameter(_this__u8e3s4, position) {
  _init_properties_Util_kt__laey5a();
  if (position === get_DEFAULT__ByteString_size())
    return _this__u8e3s4.q2();
  return position;
}
function arrayRangeEquals(a, aOffset, b, bOffset, byteCount) {
  _init_properties_Util_kt__laey5a();
  var inductionVariable = 0;
  if (inductionVariable < byteCount)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(a[i + aOffset | 0] === b[i + bOffset | 0]))
        return false;
    }
     while (inductionVariable < byteCount);
  return true;
}
function checkOffsetAndCount(size, offset, byteCount) {
  _init_properties_Util_kt__laey5a();
  if ((offset | byteCount) < 0n || offset > size || subtract(size, offset) < byteCount) {
    throw ArrayIndexOutOfBoundsException().k3x('size=' + size.toString() + ' offset=' + offset.toString() + ' byteCount=' + byteCount.toString());
  }
}
var properties_initialized_Util_kt_13atj0;
function _init_properties_Util_kt__laey5a() {
  if (!properties_initialized_Util_kt_13atj0) {
    properties_initialized_Util_kt_13atj0 = true;
    DEFAULT__new_UnsafeCursor = new (UnsafeCursor())();
    DEFAULT__ByteString_size = -1234567890;
  }
}
//region block: exports
export {
  arrayRangeEquals as arrayRangeEquals1k0armei4gb4e,
  checkOffsetAndCount as checkOffsetAndCount2b5icqlx5z1pu,
  resolveDefaultParameter as resolveDefaultParameter3hmb6x0gvzxi7,
};
//endregion

//# sourceMappingURL=Util.mjs.map
